import React, { useEffect, useState } from "react";
import { useQuery, useMutation } from "react-query";
import { useNavigate, useLocation } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import {
	onlineAccountInfo,
	findMemberByPfNumber,
	onlineCollection,
	onlineCollectionCard,
	addMomoPayment,
	addChequePayment,
	addCardPayment,
	getBankBranches,
	getBankBranchBySortcode,
} from "../../../api/apiServices";
import generateTransactionId from "../../../services/generateTransactionId";
import Loader from "../../Common/Spinner/Loader";

const mtnServiceID = `${process.env.REACT_APP_MTN_SERVICE_ID}`;
const vodafoneServiceID = `${process.env.REACT_APP_VODAFONE_SERVICE_ID}`;
const cardServiceId = `${process.env.REACT_APP_VISA_CARD_ID}`;
const languageId = `${process.env.REACT_APP_LANGUAGE_ID}`;
const countryCode = `${process.env.REACT_APP_COUNTRY_CODE}`;
const transCurrencyIso = `${process.env.REACT_APP_TRANS_CURRENCY_ISO}`;

const MemberTwoMTwoPayment = ({ member }) => {
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/member_2m2_payments";

	let curr = new Date();
	curr.setDate(curr.getDate());
	let date = curr.toISOString().substring(0, 10);
	let paymtYear = String(curr.getFullYear());

	const [isMoMo, setIsMoMo] = useState(false);
	const [findMember, setFindMember] = useState(false);
	const [isVisaCard, setIsVisaCard] = useState(false);
	const [isCheque, setIsCheque] = useState(false);
	
	const [payment_type, setPaymentType] = useState(paymtYear);
	const [payment_mode, setPaymentMode] = useState("");
	const [pf_number, setPFNumber] = useState("");
	const [mobile_number, setMobileNumber] = useState("");
	const [card_fullname, setCardFullname] = useState("");
	const [fullname, setFullname] = useState("");
	const [amount, setAmount] = useState("");
	const [payPartnerServiceId, setPayPartnerServiceId] = useState("");
	const [transaction_id, setTransactionId] = useState("");

	const [card_number, setCardNumber] = useState();
	const [expiryDateMonth, setExpiryDateMonth] = useState("");
	const [expiryDateYear, setExpiryDateYear] = useState("");
	const [cvv, setCvv] = useState("");

	const [cheque_number, setChequeNumber] = useState("");
	const [member_bank, setMemberBank] = useState("");

	const [proforum_bank, setProforumBank] = useState([]);
	const [payment_date, setPaymentDate] = useState(date);

	const [isPayWithAnotherNumber, setIsPayWithAnotherNumber] = useState(false);
	const [pay_with_another_number, setPayWithAnotherNumber] = useState("");

	const [another_phone_number, setAnotherPhoneNumber] = useState("");
	const [anotherPhoneNumberFullname, setAnotherPhoneNumberFullname] =
		useState("");

	const year = 2024;
	const years = Array.from(new Array(20), (val, index) => index + year);

	useEffect(() => {
		member?.pfNumber &&
			findMemberByPfNumber(member?.pfNumber).then((res) => {
				setMobileNumber(res.member?.mobile_number);
				setPFNumber(res.member?.pf_number);
				setFullname(
					res?.member?.first_name +
						" " +
						res?.member?.middle_name +
						" " +
						res?.member?.last_name
				);
				setFindMember(true);
			});
		generateTransactionId().then((result) => {
			setTransactionId(result);
		});
	}, [member?.pfNumber]);

	const { data: bankBranches } = useQuery("bankBranches", getBankBranches);

	const handleMobileNumberInput = (value, countryObj, e, formattedValue) => {
		const name = e.target.name;

		let mobileNumber = value.replaceAll(" ", "");

		if (mobileNumber.substring(4, 0) === "2330") {
			mobileNumber = mobileNumber.replace("0", "");
		}

		if (name === "another_phone_number") {
			setAnotherPhoneNumber(mobileNumber);
		} else {
			setMobileNumber(mobileNumber.replaceAll(" ", ""));
		}
	};

	const handlePayWithAnotherNumber = (e) => {
		const anotherNumber = e.target.value;

		setPayWithAnotherNumber(anotherNumber);
		if (anotherNumber === "YES") {
			// setIsAnotherPhoneNumber(true);
			setIsPayWithAnotherNumber(true);
		} else {
			// setIsAnotherPhoneNumber(false);
			setIsPayWithAnotherNumber(false);
		}
	};

	const handleAccountInfo = (e) => {
		const value = e.target.value.replaceAll(" ", "");
		let mobileNumber = "";
	
		if (value === "") {
			toast.error("Please enter your mobile number", {
				duration: 5000,
				className: "toast-message",
			});
			return false;
		} else if (value === "+233") {
			toast.error(
				"The mobile number is not valid. Please provide a valid mobile number to continue",
				{
					duration: 5000,
					className: "toast-message",
				}
			);
			return false;
		}

		if (value.substring(5, 0) === "+2330") {
			mobileNumber = value.replace("0", "");
		} else {
			mobileNumber = value;
		}

		const infoData = {
			CustomerAcctNo: mobileNumber,
			PayPartnerServiceId: payPartnerServiceId,
			LanguageId: languageId,
			CountryCode: countryCode,
		};
		getMemberInfoMutation.mutate(infoData);
	};

	const getMemberInfoMutation = useMutation(onlineAccountInfo, {
		onSuccess: async (res) => {
			if (res.data.Status === false && res.status === 201) {
				toast.error(res.data.Message, {
					duration: 5000,
					className: "toast-message",
				});
				return false;
			}
			if (res.data.Status === false && res.status === 200) {
				toast.error(res.data.Message, {
					duration: 5000,
					className: "toast-message",
				});
				return false;
			}
			if (res.data.Status === true) {
				generateTransactionId().then((result) => {
					setTransactionId(result);
				});
				if (!isPayWithAnotherNumber) {
					setFullname(res.data.AccountName);
					return true;
				} else {
					setAnotherPhoneNumberFullname(res.data.AccountName);
					return true;
				}
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			return false;
		},
	});

	const handleChequeNumber = (e) => {
		const value = e.target.value;
		let bankSortcode = value.substring(0, 6);
		getBankBranchBySortcode(bankSortcode).then((bank) => {
			setMemberBank(bank.branch_name);
		});
	};

	const handleOnlinePayment = (e) => {
		e.preventDefault();
		setIsLoading(true);
		const paymtMode = payPartnerServiceId;
		if (paymtMode === `${cardServiceId}`) {
			const cardPaymentData = {
				PayPartnerServiceId: payPartnerServiceId,
				AccountNoOrCardNoOrMSISDN: card_number,
				Amount: amount,
				AccountName: card_fullname.toLocaleUpperCase(),
				TransactionId: transaction_id,
				Narration: "PF Payment",
				TransCurrencyIso: transCurrencyIso,
				ExpiryDateMonth: parseInt(expiryDateMonth),
				ExpiryDateYear: parseInt(expiryDateYear.substring(2)),
				Cvv: parseInt(cvv),
				LanguageId: languageId,
			};
			onlineCollectionCardMutation.mutate(cardPaymentData);
		} else if (
			paymtMode === `${mtnServiceID}` ||
			paymtMode === `${vodafoneServiceID}`
		) {
			const momoPaymentData = {
				PayPartnerServiceId: payPartnerServiceId,
				Amount: amount,
				AccountNoOrCardNoOrMSISDN: !isPayWithAnotherNumber
					? mobile_number
					: another_phone_number,
				AccountName: fullname.toLocaleUpperCase(),
				TransactionId: transaction_id,
				LanguageId: languageId,
				Narration: "PF Payment",
				TransCurrencyIso: transCurrencyIso,
				ExpiryDateMonth: 0,
				ExpiryDateYear: 0,
				Cvv: 0,
            };
			onlineCollectionMutation.mutate(momoPaymentData);
		} else if (paymtMode === "chequeServiceId") {
			const chequePaymentData = {
				fullname: fullname.toLocaleUpperCase(),
				pf_number: pf_number.toLocaleUpperCase(),
				mobile_number: mobile_number,
				cheque_number: cheque_number,
				proforum_bank: proforum_bank.toLocaleUpperCase(),
				member_bank: member_bank.toLocaleUpperCase(),
				payment_date: payment_date,
				amount: parseFloat(amount).toFixed(2),
				payment_year: year,
				payment_mode: payment_mode.toLocaleUpperCase(),
				payment_type: payment_type.toLocaleUpperCase(),
				transaction_id: transaction_id,
			};

			addChequeMutation.mutate(chequePaymentData);
			setFullname("");
			setPFNumber("");
			setMobileNumber("");
			setChequeNumber("");
			setMemberBank([]);
			setProforumBank([]);
			setPaymentDate("");
			setAmount("");
			setPaymentType("");
			setIsLoading(false);
			setIsVisaCard(false);
			setIsMoMo(false);
			setIsCheque(false);
			
		}
	};

	const addChequeMutation = useMutation(addChequePayment, {
		onSuccess: async (res) => {
			if (res.success === true) {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
			} else {
				toast.error(res.message, {
					duration: 5000,
					className: "toast-message",
				});
			}
			setIsLoading(false);
			setIsVisaCard(false);
			setIsMoMo(false);
			setIsCheque(false);
		
			navigate(from, { replace: true });
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			setIsLoading(false);
			setIsVisaCard(false);
			setIsMoMo(false);
			setIsCheque(false);
	
			navigate(from, { replace: true });
		},
	});

	const onlineCollectionCardMutation = useMutation(onlineCollectionCard, {
		onSuccess: async (res) => {
			if (res.data.Status === true) {
				const cardPaymentData = {
					PayPartnerServiceId: payPartnerServiceId,
					amount: parseFloat(amount).toFixed(2),
					mobile_number: mobile_number,
					fullname: fullname.toLocaleUpperCase(),
					payment_year: year,
					payment_type: payment_type.toLocaleUpperCase(),
					payment_mode: payment_mode.toLocaleUpperCase(),
					pf_number: pf_number.toLocaleUpperCase(),
					transaction_id: transaction_id,
				};
				addCardPaymentMutation.mutate(cardPaymentData);
			} else if (res.data.Status === false) {
				toast.error(res.data.Message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsLoading(false);
				setIsVisaCard(false);
				setIsMoMo(false);
				setIsCheque(false);
				
				navigate(from, { replace: true });
			} else {
				toast.error(res.data.message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsLoading(false);
				setIsVisaCard(false);
				setIsMoMo(false);
				setIsCheque(false);
			
				navigate(from, { replace: true });
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			setIsLoading(false);
			setIsVisaCard(false);
			setIsMoMo(false);
			setIsCheque(false);
		
			navigate(from, { replace: true });
		},
	});

	const addCardPaymentMutation = useMutation(addCardPayment, {
		onSuccess: async (res) => {
			if (res.success === true) {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsLoading(false);
				setIsVisaCard(false);
				setIsMoMo(false);
				setIsCheque(false);
			
				setPaymentType("");
				setPFNumber("");
				setMobileNumber("");
				setFullname("");
			
				setAmount("");
				navigate(from, { replace: true });
			} else {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsLoading(false);
				setIsVisaCard(false);
				setIsMoMo(false);
				setIsCheque(false);
			
				setPaymentType("");
				setPFNumber("");
				setMobileNumber("");
				setFullname("");
				
				setAmount("");
				navigate(from, { replace: true });
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			setIsLoading(false);
			setIsVisaCard(false);
			setIsMoMo(false);
			setIsCheque(false);
			
			setPaymentType("");
			setPFNumber("");
			setMobileNumber("");
			setFullname("");
			
			setAmount("");
			navigate(from, { replace: true });
		},
	});

	const onlineCollectionMutation = useMutation(onlineCollection, {
		onSuccess: async (res) => {
			if (res.data.Status === true) {
				const momoPaymentData = {
					PayPartnerServiceId: payPartnerServiceId,
					amount: parseFloat(amount).toFixed(2),
					mobile_number: mobile_number,
					fullname: fullname.toLocaleUpperCase(),
					payment_year: year,
					payment_type: payment_type.toLocaleUpperCase(),
					payment_mode: payment_mode.toLocaleUpperCase(),
					pf_number: pf_number.toLocaleUpperCase(),
					transaction_id: transaction_id,
				};
				addMomoMutation.mutate(momoPaymentData);
			} else {
				setIsLoading(false);
				setIsVisaCard(false);
				setIsMoMo(false);
				setIsCheque(false);
				
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			setIsLoading(false);
			setIsVisaCard(false);
			setIsMoMo(false);
			setIsCheque(false);
		
			navigate(from, { replace: true });
		},
	});

	const addMomoMutation = useMutation(addMomoPayment, {
		onSuccess: async (res) => {
			if (res.success === true) {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsLoading(false);
				setIsVisaCard(false);
				setIsMoMo(false);
				setIsCheque(false);
				
				setPaymentType("");
				setPFNumber("");
				setMobileNumber("");
				setFullname("");
				setAmount("");
				navigate(from, { replace: true });
			} else {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsLoading(false);
				setIsVisaCard(false);
				setIsMoMo(false);
				setIsCheque(false);
			
				setPaymentType("");
				setPFNumber("");
				setMobileNumber("");
				setFullname("");
				setAmount("");
				navigate(from, { replace: true });
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			setIsLoading(false);
			setIsVisaCard(false);
			setIsMoMo(false);
			setIsCheque(false);
		
			setPaymentType("");
			setPFNumber("");
			setMobileNumber("");
			setFullname("");
			
			setAmount("");
			navigate(from, { replace: true });
		},
	});

	const handleSelection = (e) => {
		const modeSelection = e.target.value;

		if (modeSelection === `${cardServiceId}`) {
			setPayPartnerServiceId(modeSelection);
			setPaymentMode("B");
			setIsVisaCard(true);
			setIsMoMo(false);
			setIsCheque(false);
		} else if (
			modeSelection === `${mtnServiceID}` ||
			modeSelection === `${vodafoneServiceID}`
		) {
			setPaymentMode("M");
			setPayPartnerServiceId(modeSelection);
			setIsVisaCard(false);
			setIsMoMo(true);
			setIsCheque(false);
		} else if (modeSelection === "chequeServiceId") {
			setPaymentMode("Q");
			setPayPartnerServiceId(modeSelection);
			setIsVisaCard(false);
			setIsMoMo(false);
			setIsCheque(true);
		}
	};

	const handleCancel = () => {
		navigate("/home");
	};

	const visaCardPayment = (
		<>
			<div className="form-group row">
				<label
					htmlFor="card_number"
					className="col-sm-3 col-form-label"
				>
					Card Number<span>&nbsp;&nbsp;*</span>
				</label>
				<div className="col-sm-9">
					<input
						type="tel"
						name="card_number"
						id="card_number"
						placeholder="4531 0400 0960 0258"
						style={{
							height: "40px",
							textTransform: "uppercase",
						}}
						required
						value={card_number}
						onChange={(e) => setCardNumber(e.target.value)}
						className="form-control"
					/>
				</div>
			</div>
			<div className="form-group row">
				<label
					htmlFor="card_fullname"
					className="col-sm-3 col-form-label"
				>
					Name On Card<span>&nbsp;&nbsp;*</span>
				</label>
				<div className="col-sm-9">
					<input
						type="text"
						name="card_fullname"
						id="card_fullname"
						placeholder="FullName On Card"
						style={{
							height: "40px",
							textTransform: "uppercase",
						}}
						required
						autoComplete="off"
						value={card_fullname}
						onChange={(e) => setCardFullname(e.target.value)}
						className="form-control"
					/>
				</div>
			</div>
			<div className="form-group row">
				<label htmlFor="cvc" className="col-sm-3 col-form-label">
					CVV<span>&nbsp;&nbsp;*</span>
				</label>
				<div className="col-sm-3">
					<input
						type="number"
						name="cvc"
						id="cvc"
						placeholder="745"
						pattern="\d{3,4}"
						required
						style={{
							height: "40px",
							textTransform: "uppercase",
						}}
						onChange={(e) => setCvv(e.target.value)}
						value={cvv}
						className="form-control"
					/>
				</div>
				{/* </div>
            <div className="form-group row"> */}
				<label
					htmlFor="expiryDateMonth"
					className="col-sm-2 col-form-label"
				>
					Expiry Date<span>&nbsp;&nbsp;*</span>
				</label>
				<div className="col-sm-2">
					<select
						type="text"
						name="expiryDateMonth"
						id="expiryDateMonth"
						style={{
							height: "40px",
							textTransform: "uppercase",
						}}
						required
						onChange={(e) => setExpiryDateMonth(e.target.value)}
						value={expiryDateMonth}
						className="form-control"
					>
						<option>Month</option>
						<option value={1}>01</option>
						<option value={2}>02</option>
						<option value={3}>03</option>
						<option value={4}>04</option>
						<option value={5}>05</option>
						<option value={6}>06</option>
						<option value={7}>07</option>
						<option value={8}>08</option>
						<option value={9}>09</option>
						<option value={10}>10</option>
						<option value={11}>11</option>
						<option value={12}>12</option>
					</select>
				</div>
				<div className="col-sm-2">
					<select
						type="text"
						name="expiryDateYear"
						id="expiryDateYear"
						style={{
							height: "40px",
							textTransform: "uppercase",
						}}
						required
						onChange={(e) => setExpiryDateYear(e.target.value)}
						value={expiryDateYear}
						className="form-control"
					>
						<option>Year</option>
						{years.map((year, index) => (
							<option value={year} key={`year${index}`}>
								{year}
							</option>
						))}
					</select>
				</div>
			</div>
			<div className="form-group row">
				<label htmlFor="amount" className="col-sm-3 col-form-label">
					Amount<span>&nbsp;&nbsp;*</span>
				</label>
				<div className="col-sm-9">
					<input
						type="number"
						name="amount"
						id="amount"
						style={{
							height: "40px",
							textTransform: "uppercase",
						}}
						placeholder="Amount"
						required
						value={amount}
						onChange={(e) => setAmount(e.target.value)}
						className="form-control"
					/>
					<span>An additional fee may apply to this payment</span>
				</div>
			</div>
		</>
	);

	const chequePayment = (
		<>
			<div className="form-group row">
				<label htmlFor="cheque_number" className="col-sm-3">
					Cheque Number<span>&nbsp;&nbsp;*</span>
				</label>
				<div className="col-sm-9">
					<input
						type="text"
						name="cheque_number"
						id="cheque_number"
						placeholder="Cheque Number"
						style={{
							textTransform: "uppercase",
							height: "40px",
						}}
						required
						value={cheque_number}
						onBlur={handleChequeNumber}
						onChange={(e) => setChequeNumber(e.target.value)}
						className="form-control"
					/>
				</div>
			</div>
			<div className="form-group row">
				<label htmlFor="member_bank" className="col-sm-3">
					Member Bank<span>&nbsp;&nbsp;*</span>
				</label>
				<div className="col-sm-9">
					<input
						type="text"
						name="member_bank"
						id="member_bank"
						style={{
							textTransform: "uppercase",
							height: "40px",
						}}
						disabled
						value={member_bank}
						onChange={(e) => setMemberBank(e.target.value)}
						required
						className="form-control"
					/>
				</div>
			</div>
			<div className="form-group row">
				<label htmlFor="proforum_bank" className="col-sm-3">
					Proforum Bank<span>&nbsp;&nbsp;*</span>
				</label>
				<div className="col-sm-9">
					<select
						type="text"
						name="proforum_bank"
						id="proforum_bank"
						style={{
							textTransform: "uppercase",
							height: "40px",
						}}
						value={proforum_bank}
						onChange={(e) => setProforumBank(e.target.value)}
						required
						className="form-control"
					>
						<option>Select Bank </option>
						{bankBranches?.map((branch, index) => (
							<option value={branch.branch_name} key={index}>
								{branch.branch_name}
							</option>
						))}
					</select>
				</div>
			</div>
		</>
	);

	const mobileMoneyPayment = (
		<>
			<label
				htmlFor="pay_with_another_number"
				className="col-sm-5 col-form-label"
			>
				Pay With Another Number?
				<span>&nbsp;&nbsp;*</span>
			</label>

			<div className="col-sm-3">
				<label htmlFor="mtn_option">
					<input
						type="checkbox"
						id="mtn_option"
						name="pay_with_another_number"
						checked={pay_with_another_number === "NO"}
						value={"NO"}
						onChange={handlePayWithAnotherNumber}
					/>
				</label>
				NO
			</div>

			<div className="col-sm-3">
				<label htmlFor="pay_with_another_number">
					<input
						type="checkbox"
						id="voda_option"
						name="pay_with_another_number"
						checked={pay_with_another_number === "YES"}
						value={"YES"}
						onChange={handlePayWithAnotherNumber}
					/>
				</label>
				YES
			</div>

			{!isPayWithAnotherNumber ? (
				<>
					<label htmlFor="amount" className="col-sm-5 col-form-label">
						Amount<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-7">
						<input
							type="number"
							name="amount"
							id="amount"
							style={{
								height: "40px",
								textTransform: "uppercase",
							}}
							placeholder="Amount"
							required
							value={amount}
							onChange={(e) => setAmount(e.target.value)}
							className="form-control"
						/>
						<span>An additional fee may apply to this payment</span>
					</div>
				</>
			) : (
				<>
					<label htmlFor="another_phone_number" className="col-sm-5">
						Enter Phone Number<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-7">
						<PhoneInput
							id="another_phone_number"
							inputStyle={{
								paddingTop: 16,
								paddingRight: 14,
								paddingBottom: 15,
								paddingLeft: 58,
								fontSize: 16,
								width: "100%",
								zIndex: 1,
								height: 40,
								backgroundColor: "#F3F6F9",
							}}
							country={"gh"}
							countryCodeEditable={false}
							enableSearch={true}
							value={another_phone_number}
							inputProps={{
								name: "another_phone_number",
								required: true,
								autoFocus: true,
							}}
							onChange={(value, countryObj, e, formattedValue) =>
								handleMobileNumberInput(
									value,
									countryObj,
									e,
									formattedValue
								)
							}
							onBlur={handleAccountInfo}
						/>
					</div>
					<label
						htmlFor="anotherPhoneNumberFullname"
						className="col-sm-5 col-form-label"
					>
						Full Name (From Telco)<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-7">
						<input
							type="text"
							name="anotherPhoneNumberFullname"
							id="anotherPhoneNumberFullname"
							style={{
								height: "40px",
								fontWeight: "bold",
								textTransform: "uppercase",
							}}
							required
							disabled
							autoComplete="off"
							value={anotherPhoneNumberFullname}
							onChange={(e) =>
								setAnotherPhoneNumberFullname(e.target.value)
							}
							className="form-control"
						/>
					</div>
					<label htmlFor="amount" className="col-sm-5 col-form-label">
						Amount<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-7">
						<input
							type="number"
							name="amount"
							id="amount"
							style={{
								height: "40px",
								textTransform: "uppercase",
							}}
							placeholder="Amount"
							required
							value={amount}
							onChange={(e) => setAmount(e.target.value)}
							className="form-control"
						/>
						<span>An additional fee may apply to this payment</span>
					</div>
				</>
			)}
		</>
	);

	let twomtwoPaymentForm;
	if (isLoading) {
		twomtwoPaymentForm = (
			<div className="loader">
				<p>Processing payment. Please wait...</p>
				<Loader />
			</div>
		);
	} else {
		twomtwoPaymentForm = (
			<form onSubmit={handleOnlinePayment}>
				<div className="form-group row">
					<fieldset className="col-sm-6">
						<label htmlFor="mobile_number" className="col-sm-5">
							Registered Phone Number
							<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-7">
							<PhoneInput
								id="mobile_number"
								inputStyle={{
									paddingTop: 16,
									paddingRight: 14,
									paddingBottom: 15,
									paddingLeft: 58,
									fontSize: 16,
									width: "100%",
									zIndex: 1,
									height: 40,
									backgroundColor: "#F3F6F9",
								}}
								country={"gh"}
								countryCodeEditable={false}
								enableSearch={true}
								enableClickOutside={false}
								disableDropdown={false}
								value={mobile_number}
								inputProps={{
									name: "mobile_number",
									required: true,
									autoFocus: true,
								}}
								disabled
							/>
						</div>

						<label
							htmlFor="fullname"
							className="col-sm-5 col-form-label"
						>
							Full Name<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-7">
							<input
								type="text"
								name="fullname"
								id="fullname"
								placeholder="FullName"
								style={{
									height: "40px",
									fontWeight: "bold",
									textTransform: "uppercase",
								}}
								required
								disabled
								autoComplete="off"
								value={fullname}
								onChange={(e) => setFullname(e.target.value)}
								className="form-control"
							/>
						</div>

						<label
							htmlFor="pf_number"
							className="col-sm-5 col-form-label"
						>
							PF Number<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-7">
							<input
								type="tel"
								name="pf_number"
								id="pf_number"
								placeholder="PF Number"
								style={{
									height: "40px",
									fontWeight: "bold",
									textTransform: "uppercase",
								}}
								readOnly
								disabled
								value={pf_number}
								onChange={(e) => setPFNumber(e.target.value)}
								className="form-control"
							/>
						</div>

						<label
							htmlFor="payment_type"
							className="col-sm-5 col-form-label"
						>
							Select 2M2 Club<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-7">
							<select
								type="text"
								name="payment_type"
								id="payment_type"
								style={{
									height: "40px",
									textTransform: "uppercase",
								}}
								value={payment_type}
								onChange={(e) => setPaymentType(e.target.value)}
								required
								className="form-control"
							>
								<option value=""></option>
								<option value={"2M2-CLUB-10000"}>
									2M2 SNR CLUB GHc10000
								</option>
								<option value={"2M2-CLUB-7500"}>
									2M2 CLUB GHc7500
								</option>
								<option value={"2M2-CLUB-5000"}>
									2M2 CLUB GHc5000
								</option>
								<option value={"2M2-CLUB-3500"}>
									2M2 CLUB GHc3500
								</option>
								<option value={"2M2-CLUB-2000"}>
									2M2 CLUB GHc2000
								</option>
								<option value={"2M2-DIASPORA-CLUB"}>
									2M2 DIASPORA CLUB
								</option>
							</select>
						</div>

						<label
							htmlFor="payment_mode"
							className="col-sm-5 col-form-label"
						>
							Payment Mode<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-7">
							<select
								type="text"
								id="payment_option"
								required
								onChange={handleSelection}
								name="payPartnerServiceId"
								value={payPartnerServiceId}
								className="form-control"
							>
								<option value=""></option>
								<option value={mtnServiceID}>
									MTN Mobile Money
								</option>
								<option value={vodafoneServiceID}>Telecel Cash</option>
                                    {/* <option value={cardServiceId}>Visa/Credit/Debit Card</option>
                                    <option value={"chequeServiceId"}>Cheque</option> */}
							</select>
						</div>
						{isMoMo && mobileMoneyPayment}
					</fieldset>
				</div>
				<div className="panel-footer">
					<div className="row">
						<div className="col-sm-2">
							<button
								type="submit"
								className="btn btn-success btn-block"
							>
								Submit
							</button>
							&nbsp;&nbsp;&nbsp;&nbsp;
						</div>
						<div className="col-sm-2">
							<button
								type="button"
								onClick={handleCancel}
								className="btn btn-danger btn-block"
							>
								Cancel
							</button>
						</div>
					</div>
				</div>
			</form>
		);
	}

	return (
		<>
			<Toaster toastOptions={{ position: "top-center" }} />
			<section className="content-header">
				<h1>
					<i className="fas fa-bank"></i> Member 2M2 Payment
				</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>2M2 Special Payment</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">
								{twomtwoPaymentForm}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default MemberTwoMTwoPayment;
